import React, { useEffect, useState } from "react";
import brandLogo from "../images/eduhkliblogo.png";
import libLogo from "../images/eduhkliblogo.png";
import libLogoBw from "../images/eduhkliblogo-bw.png";
import { Button, Drawer } from "flowbite-react";
import { Link, useLocation } from "react-router-dom";
import { useAccountStore } from "../store";
import clsx from "clsx";
import Clock from "react-live-clock";

export default function Layout({ children }) {
  const { pathname } = useLocation();
  const { me, logout } = useAccountStore();
  const [drawerOpen, setDrawerOpen] = useState(false);

  const onLogoutClick = () => {
    logout();
  };

  const onDrawerClose = () => setDrawerOpen(false);

  return (
    <div className="flex flex-col min-h-screen">
      <header>
        <div className="container mx-auto">
          <div className="py-4 lg:px-0 px-4">
            <div className="flex justify-between items-center">
              <a href="https://www.lib.eduhk.hk" target="_blank" rel="noreferrer">
                <img
                  src={brandLogo}
                  alt="EdUHK Library"
                  className="lg:h-16 h-14"
                />
              </a>
              <div className="text-right lg:block hidden">
                <div className="mb-1">
                  Current Time: <Clock format={"YYYY-MM-DD HH:mm:ss"} ticking={true} className="font-bold" />
                </div>
                <div>
                  <a
                    href="https://www.lib.eduhk.hk/rooms-spaces/booking_guide"
                    className="text-orange-600"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Booking Guidelines
                  </a>
                  <span className="mx-4 text-gray-600">|</span>
                  {me ? (
                    <>
                      <span>{me.display_name}</span>
                      <button
                        className="text-orange-600 ml-2"
                        onClick={onLogoutClick}
                      >
                        (Log Out)
                      </button>
                    </>
                  ) : (
                    <Link to="/login" className="text-orange-600">
                      Log In
                    </Link>
                  )}
                </div>
              </div>
              <div class="block lg:hidden">
                <button onClick={() => setDrawerOpen(true)}>
                  <svg
                    class="w-6 h-6"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M4 6h16M4 12h16M4 18h16"
                    ></path>
                  </svg>
                </button>
                <Drawer
                  open={drawerOpen}
                  onClose={onDrawerClose}
                  position="right"
                >
                  <Drawer.Header titleIcon={() => <></>} />
                  <Drawer.Items>
                    <p className="mb-6">
                      {me ? (
                        <>
                          <span>{me.display_name}</span>
                          <button
                            className="text-orange-600 ml-2"
                            onClick={onLogoutClick}
                          >
                            (Log Out)
                          </button>
                        </>
                      ) : (
                        <Link to="/login" className="text-orange-600">
                          Log In
                        </Link>
                      )}
                    </p>
                    <nav className="divide-y">
                      <Link
                        to="/"
                        className={clsx(
                          "block text-orange-600 font-medium py-3"
                        )}
                      >
                        Rooms / Spaces
                      </Link>
                      <Link
                        to="/check-in"
                        className={clsx(
                          "block text-orange-600 relative font-medium py-3"
                        )}
                      >
                        <span className="relative">
                          Check In
                          {me && me.active_reserved_booking && (
                            <span className="absolute top-0 right-0 transform translate-x-3 flex h-2 w-2">
                              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-yellow-400 opacity-75"></span>
                              <span className="relative inline-flex rounded-full h-2 w-2 bg-yellow-300"></span>
                            </span>
                          )}
                        </span>
                      </Link>
                      <Link
                        to="/mybookings"
                        className={clsx(
                          "block text-orange-600 relative font-medium py-3"
                        )}
                      >
                        My Bookings
                      </Link>
                    </nav>
                  </Drawer.Items>
                </Drawer>
              </div>
            </div>
          </div>
        </div>
        <nav className="nav-wrap">
          <div className="container mx-auto">
            <div className="flex items-center justify-between lg:py-5 lg:px-0 px-4 py-4">
              <h1 className="font-bold lg:text-lg">
                <Link to="/">EdUHK Library Booking System</Link>
              </h1>
              <nav className="lg:block hidden space-x-4">
                <Link
                  to="/"
                  className={clsx(
                    "font-medium border-b-2 pb-1",
                    pathname === "/" || pathname.match(/^\/spaces/)
                      ? "border-white"
                      : "border-transparent"
                  )}
                >
                  Rooms / Spaces
                </Link>
                <Link
                  to="/check-in"
                  className={clsx(
                    "relative font-medium border-b-2 pb-1",
                    pathname.match(/^\/check-in/)
                      ? "border-white"
                      : "border-transparent"
                  )}
                >
                  Check In
                  {me && me.active_reserved_booking && (
                    <span className="absolute top-0 right-0 transform translate-x-2 -translate-y-1 flex h-2 w-2">
                      <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-yellow-200 opacity-75"></span>
                      <span className="relative inline-flex rounded-full h-2 w-2 bg-yellow-300"></span>
                    </span>
                  )}
                </Link>
                <Link
                  to="/mybookings"
                  className={clsx(
                    "font-medium border-b-2 pb-1",
                    pathname.match(/^\/mybookings/)
                      ? "border-white"
                      : "border-transparent"
                  )}
                >
                  My Bookings
                </Link>
              </nav>
            </div>
          </div>
        </nav>
      </header>
      <main className="flex-grow pb-20">{children}</main>
      <footer className="mt-auto bg-gray-800 text-white lg:py-4 lg:px-0 px-4 py-4">
        <div className="container mx-auto">Copyright © 2025 EdUHK Library</div>
      </footer>
    </div>
  );
}